import { OutdatedIndigoVersion } from 'app/OutdatedIndigoVersion/OutdatedIndigoVersion';
import { NewportAppVersionWarning } from 'newport/NewportAppVersionWarning';
import React from 'react';

import './VersionWarnings.scss';

export function VersionWarnings({
    clientWarnings,
    showRecommended = false,
}: {
    clientWarnings: boolean;
    showRecommended?: boolean;
}) {
    return (
        <div className="VersionWarnings">
            {clientWarnings && <OutdatedIndigoVersion />}
            <NewportAppVersionWarning showRecommended={showRecommended} />
        </div>
    );
}
